
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "balanceDynamic",
})
export default class balanceDynamic extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '余额提现'
          }, {
            value1: '选项2',
            label1: '平台扣减'
          }, {
            value1: '选项3',
            label1: '购物退款'
          }, {
            value1: '选项4',
            label1: '购物支付'
          }, {
            value1: '选项5',
            label1: '品测返现 '
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '成功'
		  }, {
		    value2: '选项2',
		    label2: '失败'
		  }],
		  value2: ''
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getWithdrawalList(1);
  }
  
  private getWithdrawalList(num:number){
  	  
  	  let datas = [];
  	  this.pageNo = num;
  	  let pageNum = this.pageNo;
  	  let pageSize = 10;
  	  let type = 1;
  	  let paramter = {
  	  		pageNum,
  	  		pageSize,
  			type
  	    };
  	  this.$http.get("system/manage/cash/out/record", {params:paramter}).then((res: any) => {
  	  	datas = res.data.data.data.data;
  	  	this.pageNo = num;
  	  	this.pageSize = res.data.data.data.pageSize;
  	  	this.tableData = datas;
  		this.tableData = this.tableData.map(item=>{
  			
  			if(item.cashOutType == 1) {
  				item.cashOutType = '微信';
  			} else if(item.cashOutType == 2) {
  				item.cashOutType = '支付宝';
  			} else if(item.cashOutType == 3) {
  				item.cashOutType = '银行卡';
  			} 
  			if(item.status == 0) {
  				item.statusStr = '申请提现';
  			} else if(item.status == 1) {
  				item.statusStr = '提现中';
  			} else if(item.status == 2) {
  				item.statusStr = '已完成';
  			}
  			return item;
  		});
  		
  	  });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	this.getWithdrawalList(this.pageNo);
  }
  private balanceStateChange(value) {
	  
	  // 余额权限
	  console.log(value);
  }
  private userStateChange(value){
	  
	  // 评论权限
    console.log(value);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleBalance(index,row){
	  
	  console.log(row);
	  this.$router.push('/User/editBalance/?id='+row.id);
  }
  private handleEdit(index,row){
  	  
  	  console.log(row);
	  this.$router.push('/User/editUser/?id='+row.id)
  }
}
